import {
    TableHead,
    TableCell,
    Table,
    TableRow,
    makeStyles,
    TableSortLabel,
    TableContainer,
    Paper,
    Button,
    TablePagination,
    TableBody,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useHistory } from 'react-router';

function EnhancedTableHead(props) {
    const { classes, headcells, order, orderBy, onRequestSort, action } = props;

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (
        <TableHead size="medium" className={classes.thead}>
            <TableRow>
                {headcells.map((headRow) => {
                    return (
                        <TableCell
                            className={classes.TableHeadCss}
                            key={headRow.id}
                            align="left"
                            sortDirection={orderBy === headRow.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headRow.id}
                                direction={orderBy === headRow.id ? order : 'asc'}
                                onClick={createSortHandler(headRow.id)}
                            >
                                {headRow.label}
                                {orderBy === headRow.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}{' '}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
                {action && (
                    <TableCell align="left" className={classes.TableHeadCss}>
                        Review
                    </TableCell>
                )}
            </TableRow>
        </TableHead>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
        padding: theme.spacing(2),
    },
    thead: {
        fontSize: 16,
        backgroundColor: 'gainsboro',
    },
    tableRow: {
        height: '50px',
        fontFamily: 'Rubik, sans-serif',
    },
    TableHeadCss: {
        backgroundColor: '#f6f6f6',
        '& span': {
            fontWeight: '700 !important',
            fontFamily: 'Rubik',
            fontSize: '13px !important',
            color: '#535353',
        },
    },
    TableCellCss: {
        fontWeight: '400',
        fontFamily: 'Rubik',
        fontSize: '14px',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

function descendingComparator(a, b, orderBy) {
    const x = typeof a[orderBy] === 'string' ? a[orderBy].toLowerCase() : a[orderBy];
    const y = typeof b[orderBy] === 'string' ? b[orderBy].toLowerCase() : b[orderBy];

    if (y < x) {
        return -1;
    }
    if (x > y) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => {
        return el[0];
    });
}

const ItecTable = ({ headcells, action, itecServiceRows, service, pageName }) => {
    // const { headcells, action, itecServiceRows, service,  pageName } = props; // need to remove
    //console.log('itecService Rows' ,itecServiceRows)
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const history = useHistory();

    // empty Rows
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, itecServiceRows.length - page * rowsPerPage);
    const classes = useStyles();

    // Handle CHange from Pagination
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // rows per page
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // SOrting data
    const handleRequestSort = (event, property) => {
        //console.log("RequestedPropert", property);
        //console.log("asc",order , orderBy);
        const isAsc = orderBy === property && order === 'asc';
        //console.log(isAsc, " IsAsc*****");
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const rowData = (rowdata) => {
        return headcells.map((col) => {
            let tabledata;
            //     tabledata = (
            //         <TableCell  align="left" key={col.id} className={classes.TableCellCss}>
            //             {openServiceData[col.id]}
            //         </TableCell>
            //     );
            //     return tabledata;
            if (col.isConcat && rowdata[col.id]) {
                const subdata = rowdata[col.id];
                const mergedData = col.concatElem.map((concatdata) => {
                    return concatdata.split('.').reduce((acc, item) => {
                        if (Object.prototype.hasOwnProperty.call(acc, item)) {
                            return acc[item];
                        }
                        return '';
                    }, subdata);
                });
                return (
                    <TableCell style={{ fontFamily: 'Rubik' }} align="left" key={col.id}>
                        {mergedData.join(' ')}
                    </TableCell>
                );
            }
            tabledata = (
                <TableCell style={{ fontFamily: 'Rubik' }} align="left" key={col.id}>
                    {rowdata[col.id]}
                </TableCell>
            );
            return tabledata;
        });
    };
    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <TableContainer>
                    <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table" size="medium">
                        <EnhancedTableHead
                            classes={classes}
                            headcells={headcells}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            action={action}
                        />
                        <TableBody>
                            {stableSort(itecServiceRows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const rowDataShow = rowData(row);
                                    let slno = 1;
                                    if (page > 0) {
                                        slno = rowsPerPage * page + 1;
                                    }
                                    slno += index;
                                    return (
                                        <TableRow hover tabIndex={-1} key={slno} className={classes.tableRow}>
                                            {rowDataShow}
                                            {action && (
                                                <TableCell align="left" className={classes.TableCellCss}>
                                                    <Button className="button-green" color="primary" variant="contained">
                                                        {' '}
                                                        Review{' '}
                                                    </Button>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow>
                                    <TableCell style={{ height: 53 * emptyRows }} colSpan={8} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10]}
                    component="div"
                    count={itecServiceRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    );
};

export default ItecTable;
